import React, { useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../../common/modal';
import { IOrderDetails, IOrderDetailsLine } from '../../../../models/order';
import './modal-styles.css';
import { RootState } from '../../../../store';
import { connect } from 'react-redux';
import { reorder, loadOrder } from '../../../../store/order/order-actions';
import { setIsBusy } from '../../../../store/api/api-status-action';
import { loadSession } from '../../../../store/session/session-actions';
import { useEffect } from 'react';
import OrderNotification from '../../../common/order-notification';

interface IReorderModal extends IModalChildProps {
    order: IOrderDetails;
    reorderResult: boolean | null | undefined;
    loadOrder: (orderNumber: string) => Promise<void>;
    setIsBusy: (isBusy: boolean) => Promise<void>;
    loadSession: () => Promise<void>;
    reorder: (
        lineItems: IOrderDetailsLine[],
        orderNumber: string
    ) => Promise<void>;
}

const ReorderModal = ({
    order,
    reorderResult,
    onAccept,
    onClose,
    setIsBusy,
    reorder,
    loadSession,
}: IReorderModal) => {
    const intl = useIntl();
    const [noLongerAvailable, setNoLongerAvailable] = useState(false);
    useEffect(() => {
        if (order.lineItems.some((item) => item.noLongerAvailable === 'True')) {
            setNoLongerAvailable(true);
        }
    }, []);
    useEffect(() => {
        if (reorderResult) {
            onClose();
        }
    }, [reorderResult]);
    const onReorder = async () => {
        setIsBusy(true);
        reorder(order.lineItems, order.orderNumber).then(() => {
            loadSession().then(() => {
                setIsBusy(false);
                onClose();
            });
        });
    };

    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        id="closeModalCancelModal"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({
                            id: 'Close',
                        })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="col-sm-12">
                    {noLongerAvailable && (
                        <OrderNotification className="alert-order alert-action">
                            <>
                                <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                <FormattedMessage
                                    id="One_or_more_not_available"
                                    defaultMessage="One or more items from your order are no longer available"
                                />
                            </>
                        </OrderNotification>
                    )}
                    <p className="text-center modal-spacing">
                        <strong>
                            <FormattedMessage
                                id="A_new_order_will_be_created"
                                defaultMessage="A new order will be created with available items."
                            />
                        </strong>
                    </p>
                    <p className="text-center modal-spacing">
                        *
                        <FormattedMessage
                            id="Standard_pricing_will_apply"
                            defaultMessage="Standard pricing will apply."
                        />
                    </p>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Cancel" defaultMessage="Cancel" />
                    </button>
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onReorder}
                    >
                        <FormattedMessage
                            id="Continue"
                            defaultMessage="Continue"
                        />
                    </button>
                </div>
            </>
        </Modal>
    );
};
const mapStateToProps = (state: RootState) => {
    return {
        reorderResult: state.reorderResult ? state.reorderResult.data : null,
    };
};

const mapDispatchToProps = {
    reorder,
    loadOrder,
    setIsBusy,
    loadSession,
};

const ReorderModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ReorderModal);

export default ReorderModalContainer;
